import { render, staticRenderFns } from "./MsjDefault.vue?vue&type=template&id=07da9577&scoped=true"
import script from "./MsjDefault.vue?vue&type=script&lang=js"
export * from "./MsjDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07da9577",
  null
  
)

export default component.exports